import Select from 'react-select'
import React, { useEffect, useMemo, useState } from 'react'
import { useForm, Controller, useFormContext, useFieldArray, useWatch } from 'react-hook-form'
import { colourStyles } from '../../../../Utils/styled-components/react-select.style'
import { MEASUREMENT_UNIT, WASTE } from '../../Utils/residuo-url'
import { fakegetRequest } from '../../../../Services/fake.service'
import { getRequest, loadSessionUser } from '../../../../Services/axios.service'
import { Tabs, Tab } from '@mui/material'
import { WasteBranch } from '../../Components/WasteBranch'

export const WasteManagement = ({ branchOffices }) => {
    const { control, formState: { errors }, watch, register, setValue, getValues } = useFormContext()
    const { fields, append, remove } = useFieldArray({
        control,
        name: 'generadorResiduos',
        rules: {
            minLength: 1
        },

    })

    const [units, setUnits] = useState()
    const [waste, setWaste] = useState()

    const [selectedUnit, setSelectedUnit] = useState()

    const [activeTab, setActiveTab] = useState(0)

    const [loadingSet, setLoadingSet] = useState(
        { units: false, waste: false, documentNumber: false }
    )

    useEffect(() => {
        fetchMeasurementUnit()
        fetchWaste()
        
    }, [])

    // const branchMemo = useMemo(() => {
    //     const branch = getValues("sucursales")
    //     return branch?.filter((b) => !b.nombre && !b.direccion).map((x, i) => i)
    // }, [watch("sucursales")])

    // useEffect(() => {
    //     if(branchMemo?.length > 0) {
    //         branchMemo.forEach((x) => branchOffices.remove(x))
    //     }
    // }, [branchMemo])

    const fetchMeasurementUnit = async () => {
        const headers = {
            Authorization: `Bearer ${loadSessionUser()}`,
        };
        const params = new URLSearchParams([['fields', 'abreviatura,id,identificador']])
        setLoadingSet((cur) => ({ ...cur, units: true }))
        const response = await getRequest(MEASUREMENT_UNIT, { params, headers })
        setLoadingSet((cur) => ({ ...cur, units: false }))
        const { success, statusCode, data } = response.data
        if (statusCode == 200 && success) {
            setUnits((cur) => data)
            setSelectedUnit((cur) => data[1])
        }
    }

    const fetchWaste = async () => {
        const headers = {
            Authorization: `Bearer ${loadSessionUser()}`,
        };
        setLoadingSet((cur) => ({ ...cur, waste: true }))
        const response = await getRequest(WASTE, { headers })
        setLoadingSet((cur) => ({ ...cur, waste: false }))
        const { success, statusCode, data } = response.data
        if (statusCode == 200 && success) {
            setWaste((cur) => data)
            data.map((type) => type.residuos.map((y) => append({ id: 0, cantidad: 0, unidadMedidaId: 2, residuoId: y.id, generadorId: 0 })))
        }
    }

    const handleActiveChange = (event, newValue) => {
        setActiveTab((cur) => newValue)
    }

    const tabProps = (index) => {
        return {
            id: `vertical-tab-${index}`,
            'aria-controls': `vertical-tabpanel-${index}`,
            label: `Sucursal ${index}`
        }
    }

    const getNameofWaste = (idResiduo) => {
        let nombre = null
        waste?.map(x => {
            const find = x?.residuos?.find(y => y.id === idResiduo)
            if (find) nombre = find?.nombre
        })
        return nombre
    }

    const shouldDisplayOther = (idResiduo, cantidad) => {
        if (!cantidad) return
        let display = false
        waste?.map(x => {
            const find = x?.residuos?.find(y => y.id === idResiduo && y.identificador === 'OTROS')
            if (find) display = true
        })
        return display
    }

    const onChangeMeasurementUnit = (unit) => {
        setSelectedUnit((cur) => unit)
    }

    const calculateSpecial = (identificator) => {
        const specialWaste = waste?.find((w) => w.identificador == identificator)?.residuos
        if (!specialWaste) return
        const specialControls = getValues("generadorResiduos")
            ?.filter((value) => specialWaste.some(s => s.id == value.residuoId))
        const specialBranchControls = getValues("sucursales")?.filter(x => x?.sucursalResiduos).flatMap(x => x.sucursalResiduos)
            ?.filter((value) => specialWaste.some(s => s.id == value.residuoId))
        // console.log(identificator, specialBranchControls )
        let calculate = 0
        specialControls?.filter(control => control.cantidad > 0).forEach(control => {
            if (units?.find(u => u.id === control.unidadMedidaId && u.identificador == "KG"))
                calculate += selectedUnit.identificador == "KG" ? control.cantidad : (control.cantidad / 1000)
            if (units?.find(u => u.id === control.unidadMedidaId && u.identificador == "TON"))
                calculate += selectedUnit.identificador == "TON" ? control.cantidad : (control.cantidad * 1000)
        })
        specialBranchControls?.filter(control => control.cantidad > 0).forEach(control => {
            if (units?.find(u => u.id === control.unidadMedidaId && u.identificador == "KG"))
                calculate += selectedUnit.identificador == "KG" ? control.cantidad : (control.cantidad / 1000)
            if (units?.find(u => u.id === control.unidadMedidaId && u.identificador == "TON"))
                calculate += selectedUnit.identificador == "TON" ? control.cantidad : (control.cantidad * 1000)
        })
        return calculate
    }

    const watchFieldArray = useWatch("generadorResiduos");
    const controlledFields = fields.map((field, index) => {
        return {
            ...field,
            ...watchFieldArray[index]
        };
    });

    const watchBranchOffice = useWatch("sucursales");
    const controlledBranchFields = branchOffices.fields.map((field, index) => {
        return {
            ...field,
            ...watchBranchOffice[index]
        }
    });

    const specialAmount = useMemo(() => calculateSpecial('ESPECIAL'), [controlledFields, selectedUnit])

    const dangerousAmount = useMemo(() => calculateSpecial('PELIGROSOS'), [controlledFields, selectedUnit])

    return (
        <section className="text-left my-4">
            <div className="border rounded-md border-bd-light my-6 px-8 py-4">
                <div className="flex items-center">
                    <span className="text-2xl font-medium text-font-primary">Cantidad Estimada a generar/año: &nbsp;</span>
                    <Select
                        noOptionsMessage={() => "Sin datos"}
                        placeholder="Seleccione un unidad de medida"
                        isLoading={loadingSet.units}
                        getOptionLabel={(option) => option?.abreviatura}
                        getOptionValue={(option) => option?.identificador}
                        options={units}
                        value={selectedUnit}
                        onChange={(newValue) => onChangeMeasurementUnit(newValue)}
                    />
                </div>
                <div className="text-lg text-font-dark my-4">
                    <p>Residuos de Manejo Especial: <span>{specialAmount}</span></p>
                    <p>Residuos de Manejo Peligrosos: <span>{dangerousAmount}</span></p>
                </div>
            </div>
            <div className="flex">
                <Tabs
                    orientation='vertical'
                    variant='scrollable'
                    value={activeTab}
                    onChange={handleActiveChange}
                    sx={{ borderRight: 1, borderColor: 'divider' }}>
                    <Tab className="text-2xl" label="Sede Central" id='vertical-tab-0' aria-controls='vertical-tabpanel-0' />

                    {branchOffices.fields.map((branch, i) => (
                        <Tab className="text-2xl" {...tabProps(i + 1)} label={`Sucursal ${branch.nombre}`} key={i+1} />
                    ))}
                </Tabs>
                <TabPanel value={activeTab} index={0} className="">
                    <div className="border border-bd-light">
                        <div className='custom-form grid grid-cols-1 tab-port:grid-cols-[repeat(8,1fr)] gap-x-8 gap-y-6 px-8 py-4'>
                            {waste?.length > 0 && waste.map((type, i) => (
                                <React.Fragment key={i}>
                                    <div className="col-span-full my-4 text-2xl text-dark font-semibold">
                                        {type.nombre}
                                        <hr className='my-4 border-bd-primary'></hr>
                                    </div>
                                    {controlledFields?.map((field, index) => {
                                        if (type?.residuos?.find(r => field.residuoId == r.id)) {
                                            return (
                                                <React.Fragment key={index}>
                                                    <div className="col-span-5 self-start tab-port:self-center text-xl text-font-dark ">
                                                        {getNameofWaste(field?.residuoId) ?? ''}
                                                    </div>
                                                    <div className="col-span-full tab-port:col-span-3 place-self-start tab-port:place-self-end flex items-center mb-6 tab-port:my-0 gap-x-4">
                                                        <input className='custom-form__input' type="number" min={0}
                                                            {...register(`generadorResiduos.${index}.cantidad`, { valueAsNumber: true })} />
                                                        <Controller
                                                            control={control}
                                                            name={`generadorResiduos.${index}.unidadMedidaId`}
                                                            render={({
                                                                field: { onChange, name, value, ref, onBlur },
                                                            }) => (
                                                                <Select
                                                                    ref={ref}
                                                                    onBlur={onBlur}
                                                                    styles={colourStyles}
                                                                    noOptionsMessage={() => "Sin datos"}
                                                                    placeholder="Seleccione"
                                                                    isLoading={loadingSet.units}
                                                                    getOptionLabel={(option) => option?.abreviatura}
                                                                    getOptionValue={(option) => option?.id}
                                                                    options={units}
                                                                    onChange={(newValue) => onChange(newValue?.id)}
                                                                    value={units?.find(c => c?.id === value) ?? null}
                                                                />
                                                            )}>
                                                        </Controller>
                                                    </div>
                                                    {shouldDisplayOther(field?.residuoId, watch(`generadorResiduos.${index}.cantidad`)) && (
                                                        <div className="custom-form__control col-span-full">
                                                            <label className='custom-form__label'>
                                                                Otros Residuos
                                                            </label>
                                                            <textarea className="custom-form__input" name="descripcion" id="descripcion" cols="30" rows="2"
                                                                {...register(`generadorResiduos.${index}.descripcion`)} />
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            )
                                        }
                                    })}
                                </React.Fragment>
                            )
                            )}
                        </div>
                    </div>
                </TabPanel>
                {waste && branchOffices.fields.map((branch, i) => 
                    (
                        <TabPanel value={activeTab} index={i + 1} key={i}>
                            <WasteBranch 
                                branchIndex={i} waste={waste} units={units} 
                                getName={getNameofWaste} 
                                displayOther={shouldDisplayOther}
                                loadingSet={loadingSet} />
                        </TabPanel>
                    )
                )}
            </div>
        </section>
    )
}


const TabPanel = ({ children, value, index, ...props }) => {
    return (
        <div className="w-full"
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}>
            {value === index ?
                children : 
                children ?
                React.cloneElement(children, {
                    hidden: true,
                }) : <div></div>
            }
        </div>
    )
}